import AlertIcon from './AlertIcon';
import AlertMain from './Alert';
const AlertTemp = AlertMain;
AlertTemp.Icon = AlertIcon; // To add typings

const Alert = AlertTemp;
export { Alert };
//# sourceMappingURL=index.js.map